(function(){
/* ---- libelles FR du widget Pickeasy (une seule option : livraison locale) ---- */
function pickFr(){
 document.querySelectorAll('#order-slots .ft-options .label-container').forEach(function(e){
  var t=(e.textContent||'').trim();
  if(t==='Local Delivery'||t==='Livraison locale')e.textContent='Livraison a domicile'.replace('a d','à d');
  e.setAttribute('data-sagfr','1');
 });
 /* Reformulation ciblee : on contacte le client, on ne l'appelle pas a 24 h pres.
    Si le texte est modifie dans Pickeasy, la regex ne matche plus et rien n'est touche. */
 document.querySelectorAll('#order-slots .additional-message').forEach(function(e){
  if(e.children.length)return;
  var t=e.textContent||'';
  if(!/vous êtes prévenu 24\s?h avant le passage de nos équipes/.test(t))return;
  var n=t.replace(/Livraison sur rendez-vous\s*:\s*vous êtes prévenu 24\s?h avant le passage de nos équipes\s*\./,
   'Livraison sur rendez-vous. Nous vous contactons avant notre passage pour confirmer.');
  if(n!==t)e.textContent=n;
 });
}

/* ---- calendrier Pickeasy : on saute les mois sans date (ouvre directement sur decembre) ---- */
var sautsMois=0,dernierSaut=0;
function moisSuivant(){
 var b=document.querySelector('#order-slots .view-next-month-button');
 if(!b||!b.getBoundingClientRect().width)return;
 var now=Date.now();
 if(now-dernierSaut>15000)sautsMois=0;
 if(sautsMois>=6)return;
 sautsMois++;dernierSaut=now;
 b.click();
}

/* ---- bouton explicite sur les cartes produit (le clic sur la photo n'etait pas evident) ---- */
function boutonsCartes(){
 document.querySelectorAll('product-card').forEach(function(c){
  if(c.querySelector('.sag-card-cta'))return;
  var a=c.querySelector('a.product-card__link');if(!a)return;
  var z=c.querySelector('.product-card__content')||c;
  var b=document.createElement('a');
  b.className='sag-btn sag-btn--sombre sag-card-cta';
  b.href=a.getAttribute('href');
  b.textContent='Choisir ce sapin';
  z.appendChild(b);
 });
}
var obs=null,minuteurObs;
function veille(){
 if(obs)return;
 if(!('MutationObserver' in window))return;
 obs=new MutationObserver(function(){clearTimeout(minuteurObs);minuteurObs=setTimeout(function(){pickFr();prixHT();moisSuivant();boutonsCartes();},120);});
 obs.observe(document.body,{childList:true,subtree:true});
}

/* ---- prix HT sous le prix TTC ---- */
/* TVA appliquee par Shopify. Une seule valeur a changer si le taux evolue. */
var TVA=0.20;
function eurFR(n){return n.toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/ | /g,' ')+' €';}
function litPrix(t){
 var m=String(t||'').match(/([\d][\d\s  .,]*)\s*€/);
 if(!m)return null;
 var s=m[1].replace(/[\s  ]/g,'');
 s=s.replace(/\.(?=\d{3}(\D|$))/g,'');
 s=s.replace(/,(\d{1,2})$/,'.$1').replace(/,/g,'');
 var v=parseFloat(s);
 return (isFinite(v)&&v>0)?v:null;
}
var INTERNE='.cart-totals__total-value,.cart-items__price,.cart-items__unit-price-wrapper';
function poseHT(el){
 if(el.closest('.sticky-add-to-cart'))return;
 var v=litPrix(el.textContent);if(v===null)return;
 var h=el.matches(INTERNE)?el:el.parentElement;
 if(!h)return;
 var n=h.querySelector(':scope > .sag-ht');
 if(!n){n=document.createElement('span');n.className='sag-ht';h.appendChild(n);}
 var t='soit '+eurFR(v/(1+TVA))+' HT';
 if(n.textContent!==t)n.textContent=t;
}
function prixHT(){
 document.querySelectorAll('span.price,'+INTERNE).forEach(poseHT);
 document.querySelectorAll('small').forEach(function(e){
  if(e.children.length)return;
  if(/Droits de douane et taxes inclus/.test(e.textContent))
   e.textContent='TVA '+Math.round(TVA*100)+' % incluse. Livraison, installation et reprise comprises dans le prix.';
 });
}

/* ---- titres restes en anglais dans le theme ---- */
function titresFr(){
 var d={'You may also like':'Vous aimerez aussi'};
 document.querySelectorAll('h1,h2,h3,h4,h5').forEach(function(e){
  if(e.children.length)return;
  var t=(e.textContent||'').trim();
  if(d[t])e.textContent=d[t];
 });
}

/* ---- cartes : hover + apparition ---- */
function cartes(){
 var secs=document.querySelectorAll("[id$='__villes'],[id$='__etapes'],[id$='__engagements'],[id$='__temoignages'],[id*='pied_pictos'],.product-grid,[class*='resource-list']");
 var l=[];
 secs.forEach(function(s){
  var c=[].slice.call(s.querySelectorAll('.group-block,.card,.product-card')).filter(function(e){
   var cs=getComputedStyle(e),bg=cs.backgroundColor;
   var fond=bg&&bg!=='rgba(0, 0, 0, 0)'&&bg!=='transparent';
   return fond||(parseFloat(cs.borderRadius)||0)>=8;});
  c=c.filter(function(e){return !c.some(function(o){return o!==e&&o.contains(e);});});
  c.forEach(function(e){if(l.indexOf(e)<0)l.push(e);});});
 return l;
}
function colonnes(){
 var secs=document.querySelectorAll("[id$='__villes'],[id$='__etapes'],[id$='__engagements'],[id$='__temoignages'],[id*='pied_pictos']");
 var l=[];
 secs.forEach(function(s){
  [].slice.call(s.querySelectorAll('.group-block')).filter(function(e){return !e.querySelector('.group-block');})
   .forEach(function(e){if(l.indexOf(e)<0)l.push(e);});});
 return l;
}
function anime(){
 if(window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
 var l=cartes();l.forEach(function(e){e.classList.add('sag-carte');});
 var col=colonnes().filter(function(e){return !l.some(function(o){return o.contains(e);});});
 var extra=[].slice.call(document.querySelectorAll('.sag-ent-pastilles li'));
 var tout=l.concat(col).concat(extra);
 l.concat(col).forEach(function(e){e.classList.add('sag-reveal');});
 if(!('IntersectionObserver' in window)){tout.forEach(function(e){e.classList.add('sag-vu');});return;}
 var io=new IntersectionObserver(function(es){es.forEach(function(e){
  if(!e.isIntersecting)return;
  var el=e.target,i=tout.indexOf(el);
  setTimeout(function(){el.classList.add('sag-vu');},(i%4)*110);
  io.unobserve(el);});},{threshold:0.12});
 tout.forEach(function(e){io.observe(e);});
}

/* ---- nettete des images ---- */
var dpr=window.devicePixelRatio||1,minuteur;
function nettete(){
 document.querySelectorAll('img').forEach(function(im){
  var w=Math.round(im.getBoundingClientRect().width);if(!w)return;
  var src=im.currentSrc||im.src;if(!src||src.indexOf('cdn.shopify.com')<0)return;
  var cible=Math.min(Math.round(w*dpr*1.25),2400);
  if(im.naturalWidth&&im.naturalWidth>=cible*0.85)return;
  if(im.getAttribute('data-sagfix')===String(cible))return;
  im.setAttribute('data-sagfix',String(cible));
  im.removeAttribute('srcset');im.removeAttribute('sizes');
  var base=src.split('?')[0],m=src.match(/[?&]v=(\d+)/);
  im.src=base+'?width='+cible+(m?'&v='+m[1]:'');
  if(im.hasAttribute('sizes'))im.sizes=w+'px';});
}
/* ---- defilement vers une ancre : le theme fait defiler .page-wrapper et non la fenetre ---- */
function allerA(el,lisse){
 var sp=el;while((sp=sp.parentElement)){var o=getComputedStyle(sp).overflowY;if((o==='auto'||o==='scroll')&&sp.scrollHeight>sp.clientHeight)break;}
 if(!sp)sp=document.scrollingElement||document.documentElement;
 var base=(sp===document.scrollingElement||sp===document.documentElement)?0:sp.getBoundingClientRect().top;
 sp.scrollTo({top:sp.scrollTop+el.getBoundingClientRect().top-base-110,behavior:lisse?'smooth':'auto'});
}
function ancreInitiale(){
 if(!location.hash||location.hash.length<2||location.search.indexOf('contact_posted=true')>-1)return;
 var el;try{el=document.querySelector(location.hash);}catch(e){return;}
 if(el)setTimeout(function(){allerA(el,false);},250);
}
function devisOk(){
 if(location.search.indexOf('contact_posted=true')<0)return;
 var s=document.getElementById('devis');if(!s||s.querySelector('.sag-form-ok'))return;
 var f=s.querySelector('.sag-form');if(f)f.style.display='none';
 var p=document.createElement('p');p.className='sag-form-ok';
 p.textContent='Merci, votre demande est bien partie. Nos équipes vous répondent sous 24 h ouvrées.';
 s.appendChild(p);allerA(s,false);
}
/* ---- formulaire devis Entreprises : offres a choix multiple, champs selon les offres, offre pre-cochee ---- */
function devisForm(){
 var f=document.querySelector('#devis .sag-form');if(!f||f.getAttribute('data-saginit'))return;
 f.setAttribute('data-saginit','1');
 var boxes=[].slice.call(f.querySelectorAll('.sag-choix input[type=checkbox]'));
 var cache=f.querySelector('input[name="contact[Offres]"]');if(!boxes.length||!cache)return;
 function choisies(){return boxes.filter(function(b){return b.checked;}).map(function(b){return b.value;});}
 function maj(){
  var v=choisies();
  cache.value=v.length?v.join(', '):'Non précisé';
  f.querySelectorAll('[data-offres]').forEach(function(l){
   var ok=l.getAttribute('data-offres').split('|').some(function(o){return v.indexOf(o)>-1;});
   l.style.display=ok?'':'none';
   l.querySelectorAll('input,select,textarea').forEach(function(i){i.disabled=!ok;});
  });
 }
 function coche(val){boxes.forEach(function(b){if(b.value===val)b.checked=true;});maj();}
 boxes.forEach(function(b){b.addEventListener('change',maj);});
 var d=document.getElementById('devis');
 document.querySelectorAll('a[data-offre]').forEach(function(a){a.addEventListener('click',function(ev){ev.preventDefault();coche(a.getAttribute('data-offre'));allerA(d,true);if(history.replaceState)history.replaceState(null,'','#devis');});});
 var m=location.search.match(/[?&]offre=([^&#]+)/);if(m)coche(decodeURIComponent(m[1].replace(/\+/g,' ')));
 maj();
}
function planifie(){clearTimeout(minuteur);minuteur=setTimeout(nettete,120);}

function init(){devisOk();devisForm();ancreInitiale();boutonsCartes();anime();planifie();pickFr();prixHT();veille();titresFr();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
addEventListener('load',planifie);addEventListener('resize',planifie);
addEventListener('scroll',planifie,{passive:true});
setTimeout(nettete,900);setTimeout(nettete,2200);setTimeout(pickFr,1400);setTimeout(pickFr,3000);setTimeout(titresFr,900);setTimeout(prixHT,1400);
})();